<template>
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.9762 75.1543H24.8058C22.6377 75.1543 21.5537 75.1543 21.0517 74.7256C20.6162 74.3536 20.385 73.7955 20.43 73.2245C20.4818 72.5664 21.2483 71.7999 22.7814 70.2668L53.2115 39.8367C54.6287 38.4194 55.3374 37.7108 56.1545 37.4453C56.8733 37.2118 57.6475 37.2118 58.3663 37.4453C59.1835 37.7108 59.8921 38.4194 61.3093 39.8367L75.1543 53.6816V57.9762M57.9762 75.1543C63.9891 75.1543 66.9955 75.1543 69.2922 73.9841C71.3123 72.9548 72.9548 71.3123 73.9841 69.2922C75.1543 66.9955 75.1543 63.9891 75.1543 57.9762M57.9762 75.1543H27.9145C21.9015 75.1543 18.8951 75.1543 16.5985 73.9841C14.5783 72.9548 12.9358 71.3123 11.9065 69.2922C10.7363 66.9955 10.7363 63.9891 10.7363 57.9762V27.9145C10.7363 21.9015 10.7363 18.8951 11.9065 16.5985C12.9358 14.5783 14.5783 12.9358 16.5985 11.9065C18.8951 10.7363 21.9015 10.7363 27.9145 10.7363H57.9762C63.9891 10.7363 66.9955 10.7363 69.2922 11.9065C71.3123 12.9358 72.9548 14.5783 73.9841 16.5985C75.1543 18.8951 75.1543 21.9015 75.1543 27.9145V57.9762M37.5771 30.4196C37.5771 34.3726 34.3726 37.5771 30.4196 37.5771C26.4666 37.5771 23.262 34.3726 23.262 30.4196C23.262 26.4666 26.4666 23.262 30.4196 23.262C34.3726 23.262 37.5771 26.4666 37.5771 30.4196Z"
      :stroke="color"
      stroke-width="7.15755"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#475467",
  },
});
</script>
